import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/AuthContext';
import { useTenant } from '../../../contexts/TenantContext';
import { useCreatorsList } from '../../../hooks/useCreatorsList';
import Sidebar from '../../admin-dashboard/components/Sidebar';
import PerformanceAnalytics from '../../../components/performance-v2/PerformanceAnalytics';

/**
 * Manager V2 Performance — Analytics scopées à l'équipe du manager.
 * Route : /manager/performance (V2Switcher) + /manager/v2/performance.
 * Feature : pages.performance.manager_drill.
 */
const ManagerV2Performance = () => {
  const { t } = useTranslation();
  const { userProfile } = useAuth();
  const { tenantName } = useTenant();
  const [collapsed, setCollapsed] = useState(false);
  const { rows, loading, error, reload } = useCreatorsList({
    managerId: userProfile?.id || null,
    includeDeparted: false,
  });

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} userEmail={userProfile?.email} />
      <main className="flex-1 min-w-0 overflow-x-hidden">
        <header className="border-b border-border bg-card sticky top-0 z-10">
          <div className="px-4 md:px-6 py-4">
            <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground">
              {t('perfV2.managerTitle', 'My performance')}
            </h1>
            <p className="text-xs text-muted-foreground mt-0.5">{tenantName} · {rows.length} {t('perfV2.creatorsLabel', 'creators')}</p>
          </div>
        </header>
        <div className="p-4 md:p-6">
          {error && (
            <div className="rounded-2xl bg-error/5 border border-error/30 p-4 text-sm text-error flex items-center justify-between mb-4">
              <span>{String(error.message || error)}</span>
              <button type="button" onClick={reload} className="px-3 py-1.5 rounded-lg border border-error/40 hover:bg-error/10 text-xs font-medium">
                {t('common.retry', 'Retry')}
              </button>
            </div>
          )}
          <PerformanceAnalytics rows={rows} loading={loading} creatorBasePath="/manager/team" />
        </div>
      </main>
    </div>
  );
};

export default ManagerV2Performance;
